<div class="sec-head">
  <h2>{{ 'Region & time' | translate }}</h2>
  <p>{{ 'How dates, times and language appear across the platform.' | translate }}</p>
</div>

<div class="grid2">
  <div class="field">
    <span id="account-timezone-label">{{ 'Time zone' | translate }}</span>
    <div class="select">
      <mat-select
        class="timezone-select"
        aria-labelledby="account-timezone-label"
        [value]="timeZoneId"
        (selectionChange)="onTimeZoneChange($event.value)"
      >
        <mat-option>
          <ngx-mat-select-search
            [(ngModel)]="timezoneSearchValue"
            [placeholderLabel]="('Search' | translate) + '...'"
            [noEntriesFoundLabel]="'No options found' | translate"
          ></ngx-mat-select-search>
        </mat-option>
        @for (timezone of timezones | filter: timezoneSearchValue; track trackById($index, timezone)) {
          <mat-option [value]="timezone.id">{{ timezone.name }}</mat-option>
        }
      </mat-select>
      <app-account-icon class="select-chevron" name="chevron-down" [size]="16"></app-account-icon>
    </div>
  </div>
  <div class="field">
    <span id="account-language-label">{{ 'Language' | translate }}</span>
    <div class="select">
      <mat-select
        class="language-select"
        aria-labelledby="account-language-label"
        [value]="languagePreference"
        (selectionChange)="onLanguageChange($event.value)"
      >
        @for (language of languages; track trackById($index, language)) {
          <mat-option [value]="language.id">{{ language.name }}</mat-option>
        }
      </mat-select>
      <app-account-icon class="select-chevron" name="chevron-down" [size]="16"></app-account-icon>
    </div>
  </div>
</div>

<div class="field field-loose">
  <span>{{ 'Time format' | translate }}</span>
  <app-account-segmented-control
    class="time-format"
    [options]="timeFormats"
    [value]="timePreference"
    [label]="'Time format' | translate"
    (valueChange)="onTimePreferenceChange($event)"
  ></app-account-segmented-control>
</div>

<div class="field field-loose">
  <span>{{ 'Date format' | translate }}</span>
  <app-account-segmented-control
    class="date-format"
    [options]="dateFormats"
    [value]="datePreference"
    [label]="'Date format' | translate"
    (valueChange)="onDatePreferenceChange($event)"
  ></app-account-segmented-control>
</div>

<div class="field field-loose">
  <span>{{ 'Default map location' | translate }}</span>
  <div class="location" [class.location-empty]="!locationDisplay">
    <app-account-icon name="map-pin"></app-account-icon>
    <span class="location-text">{{ locationDisplay || ('No default location set' | translate) }}</span>
    <button type="button" class="as-btn-ghost set-location" (click)="setLocation.emit()">
      {{ (locationDisplay ? 'Change location' : 'Set location') | translate }}
    </button>
  </div>
</div>
